'use client';

import { memo } from 'react';
import type { CSSProperties } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import useStyles from './styles';

interface LazyPhotoProps {
  src: string;
  width: number;
  height: number;
  alt?: string;
  title?: string;
  className?: string;
  mediaClassName?: string;
  style?: CSSProperties;
  priority?: boolean;
  blurDataUrl?: string;
  dataTestId?: string;
  sizes?: string;
}

const DEFAULT_SIZES = '(max-width: 640px) 90vw, (max-width: 1024px) 45vw, (max-width: 1440px) 18vw, (max-width: 1920px) 18rem, 14rem';

const LazyPhoto = ({ src, width, height, alt, title, className, mediaClassName, style, blurDataUrl, priority = false, dataTestId, sizes = DEFAULT_SIZES }: LazyPhotoProps) => {
  const classes = useStyles();
  const aspectRatio = `${width}/${height}`;
  const imageAlt = alt || title || 'Template preview image';

  return (
    <div className={classNames('group', classes.root, className)} style={{ aspectRatio, ...style }} data-testid={dataTestId}>
      <Image
        src={src}
        alt={imageAlt}
        width={width}
        height={height}
        priority={priority}
        fetchPriority={priority ? 'high' : 'auto'}
        blurDataURL={blurDataUrl}
        className={classNames(classes.image, mediaClassName)}
        style={{ aspectRatio }}
        sizes={sizes}
      />
    </div>
  );
};

export default memo(LazyPhoto);
